var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,9v6.4l-1.85-1.85c-.37-.37-.83-.54-1.38-.52-.55.02-1.01.21-1.38.58-.37.37-.55.83-.55,1.4s.18,1.03.55,1.4l5.2,5.2c.4.4.87.6,1.4.6s1-.2,1.4-.6l5.25-5.25c.37-.37.54-.83.53-1.38-.02-.55-.21-1.01-.58-1.38s-.83-.55-1.4-.55-1.03.18-1.4.55l-1.8,1.8v-6.45c0-.57-.19-1.03-.58-1.4-.38-.37-.86-.55-1.42-.55s-1.04.19-1.43.58c-.38.38-.57.86-.57,1.42Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownThick);
export default __webpack_public_path__ + "static/media/ArrowDownThick.b82e53b800fff954449a3db60b565d95.svg";
export { ForwardRef as ReactComponent };